import React from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

export interface ConfirmarEnvioFacturaEmailDialogProps {
  open: boolean;
  sending?: boolean;
  clienteTieneEmail: boolean;
  emailsSugeridos: string[];
  nombreCliente?: string | null;
  comprobanteLabel?: string | null;
  onNoEnviar: () => void;
  onEnviar: () => void;
}

const ConfirmarEnvioFacturaEmailDialog: React.FC<ConfirmarEnvioFacturaEmailDialogProps> = ({
  open,
  sending = false,
  clienteTieneEmail,
  emailsSugeridos,
  nombreCliente,
  comprobanteLabel,
  onNoEnviar,
  onEnviar,
}) => {
  const emailsLabel = emailsSugeridos.join(', ');

  return (
    <Dialog
      open={open}
      onClose={sending ? undefined : onNoEnviar}
      maxWidth="xs"
      fullWidth
      // Por encima de «Venta completada» / «Factura Creada»
      sx={{ zIndex: (theme) => theme.zIndex.modal + 10 }}
    >
      <DialogTitle>¿Enviar factura por mail?</DialogTitle>
      <DialogContent>
        {comprobanteLabel ? (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Comprobante: <strong>{comprobanteLabel}</strong>
            {nombreCliente ? ` — ${nombreCliente}` : ''}
          </Typography>
        ) : null}
        {clienteTieneEmail ? (
          <Typography variant="body1">
            Se enviará a: <strong>{emailsLabel}</strong>
          </Typography>
        ) : (
          <Typography variant="body1">
            El cliente no tiene un email válido. Si continuás, vas a poder indicar el destinatario.
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onNoEnviar} disabled={sending} color="inherit">
          No enviar
        </Button>
        <Button
          onClick={onEnviar}
          variant="contained"
          disabled={sending}
          startIcon={sending ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          {sending ? 'Enviando…' : clienteTieneEmail ? 'Enviar' : 'Continuar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmarEnvioFacturaEmailDialog;
